import React from 'react';

import { FieldErrorInfoIcon } from '../../icons/FieldErrorInfoIcon';

export interface FieldErrorMessageProps {
  message: string;
}

export const FieldErrorMessage = ({ message }: FieldErrorMessageProps) => (
  <span className="inline-flex w-full min-w-0 items-center gap-1">
    <span className="inline-flex shrink-0" aria-hidden>
      <FieldErrorInfoIcon />
    </span>
    <span className="min-w-0 text-sm" style={{color: '#EF4444'}}>{message}</span>
  </span>
);
